import { controlUpdates } from './src/control';

export { controlUpdates };
class Store {
  init({ dispatch, getState, subscribe, replaceReducer }) {
    this.dispatch = dispatch;
    this.getState = getState;
    this.subscribe = subscribe;
    this.replaceReducers = replaceReducer;
    this._subscriptions = [];
  }

  control(controllers) {
    return instance => {
      const controllersToSubscribe = controllers(instance);

      // Allow components to receive Redux state on connect
      const state = this.getState();

      const orderControllers = Array.isArray(controllersToSubscribe)
        ? controllersToSubscribe
        : Object.values(controllersToSubscribe);

      orderControllers.forEach(({ selector, callback, shouldBeInvokedOnConnect }) => {
        if (shouldBeInvokedOnConnect && callback && selector) {
          callback(selector(state));
        }
      });

      const unsubscribe = this.subscribe(controlUpdates(controllersToSubscribe, this.getState));

      const result = () => {
        const keys = Object.keys(controllers);
        for (let i = 0; i < keys.length; i += 1) {
          const controller = controllers[keys[i]];
          controller._previousProp = undefined;
        }

        this._subscriptions = this._subscriptions.filter(subscription => subscription !== result);

        unsubscribe();
      };
      this._subscriptions.push(result);

      return result;
    };
  }

  cleanup = () => {
    this._subscriptions.forEach(unsubscribe => {
      unsubscribe();
    });

    this.dispatch = null;
    this.getState = null;
    this.subscribe = null;
    this.replaceReducers = null;
    this._subscriptions = [];
  };
}

export default new Store();
